import axios from "../../../../../axios";
import Cookies from "js-cookie";

export const GetSelectedCandidate = async () => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/GetSelectedCandidates", {
    token,
  });
};